import { useState } from "react";
import { Card, Stack, Typography, IconButton, Collapse, Box, CardProps } from "@mui/material";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { Job } from "../../Jobs/types";
import { User } from "../../../types/User";
import CustomMDPreview from "../../../components/CustomMD/CustomMDPreview";
import { getSpacedFromCamel_Cap } from "../../../util/string";

interface PreviewItemProps {
    item: Job | User;
    cardProps?: CardProps;
}

const PreviewItem = ({ item, cardProps }: PreviewItemProps) => {
    const [open, setOpen] = useState(false);
    const header = typeof item === 'object' && 'title' in item ? item.title : item.fullName;

    return (
        <Card {...cardProps}>
            <Stack sx={{ p: 1.5 }}>
                <Stack direction="row" justifyContent="space-between" alignItems="center">
                    <Typography variant="subtitle1">{header}</Typography>
                    <IconButton onClick={() => setOpen(!open)} size="small">
                        {open ? <ExpandLess /> : <ExpandMore />}
                    </IconButton>
                </Stack>
                <Collapse in={open}>
                    <Stack gap={1} mt={1}>
                        {Object.keys(item)
                            .filter(key => key !== 'duplicated')
                            .map((objectKey) => (
                                <Box key={objectKey}>
                                    <Typography>{getSpacedFromCamel_Cap(objectKey)}</Typography>
                                    <Box sx={{ mt: 1, border: '1px solid #e0e0e0', p: 1, borderRadius: 1 }}>
                                        <CustomMDPreview description={item[objectKey as keyof typeof item]} />
                                    </Box>
                                </Box>
                            ))}
                    </Stack>
                </Collapse>
            </Stack>
        </Card>
    );
};

export default PreviewItem; 